export default __webpack_public_path__ + "static/media/July_01.a62ceee8.png";